<template>
  <div class="main_center">

    <div class="content">

      <el-form ref="form" :model="form" label-width="120px">
        <el-row>
            <el-col :span="7">
                <el-form-item label="年份：" style="margin-bottom: 10px">
                    <el-select v-model="form.year" value-key="value" style="width:100%;"  @change="yearsChange">
                        <el-option v-for="(item,index) in yearsList"
                                   :key="index"
                                   :label="item"
                                   :value="item"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
          <el-col :span="7" :offset="1" >
            <el-form-item label="标段名称：">
              <el-input v-model="form.bidName"  @keydown.enter.native.stop="getDataList"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="1" v-if="moreSearchItem">
            <el-form-item label="招标人：">
              <el-input v-model="form.tenderName"  @keydown.enter.native.stop="getDataList"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" v-if="moreSearchItem">
            <el-form-item label="招标代理机构：">
              <el-input v-model="form.tenderAgentName"  @keydown.enter.native.stop="getDataList"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1" v-if="moreSearchItem">
            <el-form-item label="交易中心：">
              <el-select v-model="form.tradeId" value-key="value" style="width:100%;">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(item,index) in transactionCenterList" :key="index" :label="item.orgName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <div style="float:right;margin-right: 10px;margin-bottom: 10px">
            <el-button size="mini" type="text" v-if="!moreSearchItem" @click="moreSearchItem = true" icon="el-icon-arrow-down">展开</el-button>
            <el-button size="mini" type="text" v-if="moreSearchItem" @click="moreSearchItem = false" icon="el-icon-arrow-up">收起</el-button>
            <el-button size="small" type="primary" style="margin-left:30px;" @click="seachBtn">搜索</el-button>
            <el-button plain size="small" type="primary" style="margin-left:10px;"  @click="reflash">重置</el-button>
          </div>
        </el-row>
      </el-form>
<!--        <div style="position: relative;top:-10px">-->
<!--            <el-button size="small" v-if="deleteBtnShow" icon="el-icon-delete" type="primary"-->
<!--                       @click="deleteSelectItem()">批量删除-->
<!--            </el-button>-->
<!--            <el-button size="small" v-if="deleteBtnShow" icon="el-icon-success" type="primary"-->
<!--                       @click="selectAll(true)">全选-->
<!--            </el-button>-->
<!--            <el-button size="small" v-if="deleteBtnShow" icon="el-icon-success" type="primary"-->
<!--                       @click="selectAll(false)">反选-->
<!--            </el-button>-->
<!--            <el-button size="small" :icon="deleteBtnShow?'el-icon-close':'el-icon-delete'" type="primary"-->
<!--                       @click="triggerDeleteBtn">{{deleteBtnShow?'取消':'删除数据'}}-->
<!--            </el-button>-->
<!--        </div>-->
        <el-row :gutter="15" :style="{'min-height':tableMaxHeight}" v-loading="dataListLoading">
            <el-col :span="8" v-for="item in list" :key="item.id">
                <el-card class="projectCard"  >
                    <p class="deleteBtn" v-if="deleteBtnShow">
                        <i :style="{'color':hasSelect(item.id)?'#5cb6ff':'#c0c4cc'}"  @click="triggerSelectItem(item.id)" :class="hasSelect(item.id)?'el-icon-circle-check':'el-icon-circle-close'"></i>
                    </p>
                    <img class="pdfImg" :src="(item.attachments && item.attachments[1] && item.attachments[1].filePath) || ''">
                    <div class="baseInfo">
                        <h3 class="projectTitle" :title="item.bidName">{{ item.bidName }}</h3>
                        <p class="ellipsis" :title="item.bidCode"><span>{{item.bidCode}}</span></p>
                        <p class="info"><span>招标人：</span><span >{{item.tenderName}}</span></p>
                        <p class="info"><span>代理机构：</span><span >{{item.tenderAgentName}}</span></p>
                        <p class="info"><span>出证时间：</span><span >{{item.cateoutQuest && formatDate(item.cateoutQuest.processinstanceEndDate,'yyyy-MM-dd HH:mm')}}</span></p>
                        <el-button size="small" plain type="primary"  @click="showDetail(item.id)">查看</el-button>
                    </div>
                    <div style="clear: both"></div>
                </el-card>
            </el-col>
            <emptyInfo v-if="list.length == 0" :emptyMsg="'暂无记录'" ></emptyInfo>
        </el-row>

      <!-- <el-pagination
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
              :current-page="pageIndex"
              :page-sizes="[pageSize, 20, 50, 100]"
              :page-size="pageSize"
              :total="total"
              layout="sizes, prev, pager, next">
      </el-pagination> -->
      <pagination
                class="limit"
                :page-sizes="[pageSize, 20, 50, 100]"
                :total="total"
                :page.sync="pageIndex"
                :limit.sync="pageSize"
                @pagination="paginationChange">
      </pagination>     
    </div>




  </div>
</template>

<script>
    import {mapState} from "vuex";
    import {nearSixYearsList} from '@/utils/index';
    import emptyInfo from '@/components/empty-info';
    import Pagination from '@/components/Pagination.vue';

    export default {
    components: {
        emptyInfo,
        Pagination
    },
  data() {
    return {
      tableMaxHeight: document.documentElement.clientHeight - 234,
        dataListLoading: false,
      moreSearchItem:false,
        deleteBtnShow:false,
        selectDeleteList:[],
      personRoleList: [],
      inoutFlagList: [],
      datetimerange: [],
      guardListData: [],
        yearsList:[],
      form: {
      year:new Date().getFullYear(),
        bidName: '',
        tenderName: '',
        tenderAgentName: '',
        tradeId: '', // 交易中心ID
      },
      checkList1: '',
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      tableData: [],
      multipleSelection: [],
      user: '', //角色类型
      formData: {},
      list: [],
      transactionCenterList: [],
    }
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    }),
  },
  filters: {
    ellipsis(text, num) {
      if (text.length > num) {
        return text.substring(0, num) + '...';
      } else {
        return text;
      }
    },
  },
  created() {
      this.yearsList = nearSixYearsList(this.form.year)
    this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));
  },
  activated() {
    //this.user = this.stateData.pageRoleIds //角色类型
    // this.reflash()
      this.getDataList()
  },
  mounted() {
    const that = this;
    let resizeTag = true
    window.onresize = () => {
      if (resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();
  },
  methods: {
    ifmove() {

        this.tableMaxHeight = ( document.documentElement.clientHeight - 234 ) + 'px';
        this.pageIndex = 1
        if(document.documentElement.clientHeight >900){
            this.pageSize = 9
        }else if(document.documentElement.clientHeight < 770){
            this.pageSize = 6
        }else{
            this.pageSize = 6
        }
       // this.getDataList()
    },

      triggerDeleteBtn(){
          this.deleteBtnShow = !this.deleteBtnShow;
          this.selectDeleteList = [];
      },
      hasSelect(id){
          let index = this.selectDeleteList.indexOf(id);
          return index > -1
      },
      triggerSelectItem(id){
          let index = this.selectDeleteList.indexOf(id);
          if(index > -1){
              this.selectDeleteList.splice(index,1);
          }else{
              this.selectDeleteList.push(id)
          }
      },

      selectAll(flag){
          const that = this;
          this.list.forEach(item=>{
              let index = that.selectDeleteList.indexOf(item.id)
              if(flag && index == -1){
                  that.selectDeleteList.push(item.id)
              }
              if(!flag){
                  that.triggerSelectItem(item.id)
              }
          })
      },

      deleteSelectItem() {
          if (this.selectDeleteList.length > 0) {

              this.$confirm(`确定要删除该数据?`, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(() => {
                  // FIXME 接口对接
                  // this.$http.post('/businessFlowWitness/delete',{
                  //   ids:this.selectDeleteList
                  // }).then(res => {
                  //   if (res.data.code == '1') {
                  //     this.$message({
                  //       type: 'success',
                  //       message: res.data.msg
                  //     })
                  //     this.getDataList();
                  //   } else {
                  //     this.$message({
                  //       type: 'error',
                  //       message: res.data.msg
                  //     })
                  //   }
                  // })
              })
          } else {
              this.$message({
                  type: 'error',
                  message: "未选择删除项。"
              })
          }
      },



    getDataList() { // 获取列表数据
        this.dataListLoading=true;
      this.$http.post('/cateQuestBase/cateQuestNoteList', {
        'page': this.pageIndex,
        'rows': this.pageSize,
        'searchKey': '',
        'filter': this.form
      }).then(res => {
          this.dataListLoading=false;
        this.list = res.data.rows;
        this.total = res.data.total;
      })
    },
      yearsChange(val){
          this.yearsList = nearSixYearsList(val)
          this.getDataList()
      },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    seachBtn() { //搜索按钮
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getDataList()
    },
    reflash() {//刷新按钮
        this.pageIndex = 1;
      this.$refs['form'].resetFields();

      this.form.bidName = ""
      this.form.tenderName = ""
      this.form.tenderAgentName = ""
      this.form.tradeId = ''
      this.getDataList()

    },




    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    paginationChange(obj){
        this.pageIndex= obj.page||1
        this.pageSize=obj.limit||10
        this.getDataList();
        },


    showDetail(id) {

      this.$router.push({
        name: "catequest_note_detail",
        query:{
          id:id
        }
      });
    }


  }


}
</script>

<style lang="less" scoped>
    .projectCard{

        .pdfImg{
            width: 150px;height: 180px;border:1px solid #c0c4cc;
            display: inline-block;
            float: left;
        }
        .baseInfo{
            width: calc(100% - 160px);display: inline-block;margin-left: 10px;
            float: right;
            .projectTitle{
                font-size: 22px;
                font-weight: 600;
                margin: 10px 0px;
                white-space:nowrap;
                overflow:hidden;
                text-overflow:ellipsis;
            }
            .ellipsis{
                white-space:nowrap;
                overflow:hidden;
                text-overflow:ellipsis;
            }

        }


        padding: 14px;
        position: relative;
        /deep/ .el-card__body{
            padding: 0;
        }
        /deep/ .el-card__header{
            padding: 16px 16px 0px 16px;
        }
        p{
            margin: 10px 0px;
        }
        p.info{
            margin: 10px 0px;
        }


    }


</style>